// Angular
import { Component, Inject } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

@Component({
  selector: 'kt-approve-shipment-dialog',
  templateUrl: './approve-shipment-dialog.component.html',
  styleUrls: ['./approve-shipment-dialog.component.scss'],
})
export class ApproveShipmentDialogComponent {
  // Public properties
  viewLoading = false;

  /**
   * Component constructor
   *
   * @param dialogRef: MatDialogRef<ApproveShipmentDialogComponent>
   * @param data: any
   */
  constructor(
    public dialogRef: MatDialogRef<ApproveShipmentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  /**
   * Close dialog with false result
   */
  onNoClick(): void {
    this.dialogRef.close();
  }

  /**
   * Close dialog with true result
   */
  onYesClick(): void {
    /* Server loading imitation. Remove this */
    this.viewLoading = true;
    this.dialogRef.close(true); // Keep only this row
  }
}
